import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { ErrorRoutes } from '@homesusa/core';
import { AuthRoutes } from '../enums';

export const useErrorInterceptor = (): void => {
  const navigate = useNavigate();

  React.useEffect(() => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response) {
          if (error.response.status == 401) {
            navigate(AuthRoutes.Logout, { replace: true });
          } else if (error.response.status == 403) {
            navigate(ErrorRoutes.ForbiddenError, { replace: true });
          } else if ([500, 502, 404].includes(error.response.status)) {
            console.error(error.response?.data?.message ?? error.response);
            return;
          }
        }
        throw error;
      }
    );
  }, []);
};
